import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, inject } from '@angular/core';
import { EventBasic } from '../../../data-services/models/events/event-basic.model';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { EventComplete } from '../../../data-services/models/events/event-complete.model';
import { EventDetailed } from '../../../data-services/models/events/event-detailed.model';
import { EventHelper } from '../../../data-services/helpers/events.helper';
import { Store } from '@ngrx/store';
import { selectEvent } from '../../../data-services/stores/selectors/events.selectors';
import { tap } from 'rxjs';

@Component({
  selector: 'app-event-summary',
  imports: [CommonModule, RouterModule,DividerModule],
  providers: [EventHelper],
  templateUrl: '../ui/summary.component.html',
  styleUrl: '../ui/summary.component.css'
})
export class EventsSummaryComponent implements OnInit,OnChanges{
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  event$ = this._store.select(selectEvent(this._route.snapshot.params["id"])).pipe(tap(event => {
    if (event) this.event = event;
  })).subscribe()
  public _eventHelper!: EventHelper;
  @Input({ required: true }) event!: EventBasic | EventDetailed | EventComplete;
  @Input() includeBookingLink: boolean = true;
  @Output() bookingButtonClicked = new EventEmitter()

  expandedPanel: boolean = false;

  playerTickets?: TicketDisplay;
  monsterTickets?: TicketDisplay;
  staffTickets?: TicketDisplay;

  ngOnInit(): void {
    this._eventHelper = new EventHelper(this.event as EventComplete);
    this.expandedPanel = this.includeBookingLink;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.expandedPanel = this.includeBookingLink;
    if (this.event) {
      if ((this.event as EventDetailed).eventTickets !== undefined) {
        const playerTicketsArray = (this._eventHelper)?.playerTickets ?? []; // (this.event as EventDetailed).eventTickets.filter(x => x.name === 'Player' && x !== undefined);
        const monsterTicketsArray = (this._eventHelper)?.crewTickets ?? [] // (this.event as EventDetailed).eventTickets.filter(x => x.name === 'Crew' && x !== undefined);
        const staffTicketsArray = (this._eventHelper)?.staffTickets ?? []; // (this.event as EventDetailed).eventTickets.filter(x => x.name === 'Staff' && x !== undefined);

        if (playerTicketsArray.length > 0) {
          this.playerTickets = {
            display: true,
            cost: playerTicketsArray.sort((a, b) => a.cost - b.cost)[0].cost,
            dateFrom: playerTicketsArray.sort((a, b) => new Date(a.availableFrom).getDate() - new Date(b.availableFrom).getDate())[0].availableFrom,
            dateTo: playerTicketsArray.sort((a, b) => new Date(b.availableTo).getDate() - new Date(a.availableTo).getDate())[0].availableTo
          }
        }

        if (monsterTicketsArray.length > 0) {
          this.monsterTickets = {
            display: true,
            cost: monsterTicketsArray.sort((a, b) => a.cost - b.cost)[0].cost,
            dateFrom: monsterTicketsArray.sort((a, b) => new Date(a.availableFrom).getDate() - new Date(b.availableFrom).getDate())[0].availableFrom,
            dateTo: monsterTicketsArray.sort((a, b) => new Date(b.availableTo).getDate() - new Date(a.availableTo).getDate())[0].availableTo
          }
        }

        if (staffTicketsArray.length > 0) {
          this.staffTickets = {
            display: true,
            cost: staffTicketsArray.sort((a, b) => a.cost - b.cost)[0].cost,
            dateFrom: staffTicketsArray.sort((a, b) => a.availableFrom.getDate() - b.availableFrom.getDate())[0].availableFrom,
            dateTo: staffTicketsArray.sort((a, b) => b.availableTo.getDate() - a.availableTo.getDate())[0].availableTo
          }
        }
      }
    }
  }
}

export interface TicketDisplay{
  cost?: number;
  dateFrom?: Date;
  dateTo?: Date;
  display: boolean;
}
